
import { Component, Mixins, Prop } from 'vue-property-decorator';
import SocialLinks from '@/features/auth/components/signIn/SocialLinks.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import store from '@/features/common/store';

@Component({
  components: {
    SocialLinks,
  },
})
export default class AccountStatusCard extends Mixins(ResponsivenessMixin) {
  @Prop({ type: String, required: true })
  private readonly i18nKey!: string;

  // eslint-disable-next-line class-methods-use-this
  private created(): void {
    store.dispatch('logout');
  }
}
